import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined'
import ViewQuiltOutlinedIcon from '@mui/icons-material/ViewQuiltOutlined'

/** Template `icon` names → icons; unknown names get a generic one. */
const ICONS = {
  sales: TrendingUpIcon,
  home: HomeWorkOutlinedIcon,
  bank: AccountBalanceOutlinedIcon,
  people: GroupsOutlinedIcon,
  support: SupportAgentOutlinedIcon,
}
export const templateIcon = (name) => ICONS[name] || ViewQuiltOutlinedIcon

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

/** "4 record types · 3 automations · 2 roles · 3 views · 1 dashboard" */
export const contentsSummary = (t) => [
  plural(t.recordTypes.length, 'record type'),
  t.automations.length && plural(t.automations.length, 'automation'),
  t.roles.length && plural(t.roles.length, 'role'),
  t.views.length && plural(t.views.length, 'view'),
  t.dashboards.length && plural(t.dashboards.length, 'dashboard'),
].filter(Boolean).join(' · ')

export const FIELD_TYPE_LABELS = {
  TEXT: 'Text', TEXTAREA: 'Long text', NUMBER: 'Number', DECIMAL: 'Decimal', CURRENCY: 'Currency', EMAIL: 'Email',
  PHONE: 'Phone', URL: 'Link', DATE: 'Date', DATETIME: 'Date & time', CHECKBOX: 'Checkbox', SELECT: 'Dropdown',
  MULTI_SELECT: 'Multi-select', RADIO: 'Choice', LOOKUP: 'Link to record', USER: 'Person',
}
